const SIGNUP_SUCCESS = 'Successfully Registered. Given email address will receive email once approved.'
const SOMETHING_WENT_WRONG = 'Something went wrong'
const SIGNIN_SUCCESS = 'Logged In'
const SIGNIN_FAILED = 'Incorrect email ID or password'
const INVALID_VPP = 'Invalid Virtual Power Plant'
const SERVER_DOWN = 'Technical issue, please try again later'
export {
  SIGNUP_SUCCESS,
  SOMETHING_WENT_WRONG,
  SIGNIN_SUCCESS,
  SIGNIN_FAILED,
  INVALID_VPP,
  SERVER_DOWN
}
